export function truncateFile(n: string, len = 20): string {
  const ext = n.substring(n.lastIndexOf(".") + 1, n.length);
  let filename = n.replace("." + ext, "");
  if (filename.length <= len) {
    return n;
  }
  filename = filename.substring(0, len) + (n.length > len ? "..." : "");
  return filename + "." + ext;
}
